import axios from 'axios';
import { configureSessionInterceptors } from '@/session/axiosInterceptors';
import { API_BASE_URL } from './apiConfig';

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});
configureSessionInterceptors(instance, {
  etagMethods: new Set(['put', 'patch']),
  transport: 'api',
});

export const api = instance;
